import {
    Backdrop, CircularProgress, Container, Divider,
    Grid
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import SelectSupplier from '../../components/Form/SelectSupplier';
import SelectVehicleType from '../../components/Form/SelectVehicleType';
import Success from '../../components/Form/Success';
import TextField from '../../components/Form/TextField';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { ASN, ASNPost } from '../../interfaces/Asn';
import AsnApi from '../../services/AsnApi';
import permissions from '../../utils/Permissions';
import ASNRemitoList from './ASNRemitoList';
import { useStyles } from './Style';

const opcoes = [
    { url: '/CrearASN', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/ASN/AsnArg', descricao: 'Pesquisar', state: {}}
]

interface Params {
    asnId?: string;
}

const SubmitASN: React.FC = () => {
    const params = useParams<Params>()
    const classes = useStyles();
    const [asns, setAsns] = useState<any>();
    const [asn, setAsn] = useState<any | null>(null);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("ASN");
    const { t: tval } = useTranslation("Validation");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [circularLoading, setCircularLoading] = useState(false)
    const [success, setSuccess] = useState(false);
    
    const asnStatusesToAlter = ["RAS", "EMT"];

    useEffect(() => {
        if (!hasPermission(permissions.ASN.Crear))
            history.replace('NoPermission');
    }, [history, user])

    useEffect(() => {
        
        const getMvm = async () => {
            
            if(params.asnId != null && params.asnId != "")
            {
                setCircularLoading(true);
                var asn : ASN = (await AsnApi.search({AsnId : +params.asnId!, pageIndex:0, pageSize:0})).items[0];

                setAsn(asn);
                reset({
                    supplier: {
                        label: asn.shippingCompanySupplierId + "- " + asn.shippingCompanySupplierCorporateName,
                        code: asn.shippingCompanySupplierId,
                        name: asn.shippingCompanySupplierCorporateName
                    },
                    originSupplier: {
                        label: asn.originSupplierId + " - " + asn.originSupplierCorporateName,
                        code: asn.originSupplierId,
                        name: asn.originSupplierCorporateName
                    },
                    destinySupplier: {
                        label: asn.destinationSupplierId + " - " + asn.destinationSupplierCorporateName,
                        code: asn.destinationSupplierId,
                        name: asn.destinationSupplierCorporateName
                    },
                    motorVehiclePlateNumber: asn.vehiclePlateNumber,
                    vehicleBrand: asn.vehicleBrandDescription,
                    cartPlateNumber: asn.cartPlateNumber,
                    vehiclePlateNumber2: asn.vehiclePlateNumber2,
                    vehiclePlateNumber3: asn.vehiclePlateNumber3,
                    harborLetterNumber: asn.harborLetterNumber,
                    remitos: asn.remitos
                });            
            }

                setCircularLoading(false);
        };

        getMvm();
    }, []);

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setError, resetField, setValue, setFocus, clearErrors } = useForm<any>({
        defaultValues: {
            supplier: {
                label: 27294 + " - " + "BCUBE LOGISTIC LTDA.         *               ", 
                code: 27294,
                name: "BCUBE LOGISTIC LTDA.         *               ",
                cnpj: "09174577000437",
                companyId: 154,
                shippingSupplierScacCode: "8BCU",
                shippingSupplierSapCode: 21002
            },
            originSupplier: {
                label: 1111 + " - " + "FCA FIAT CHRYSLER AUTOMOVEIS *               ", 
                code: 1111,
                name: "FCA FIAT CHRYSLER AUTOMOVEIS *               ",
                cnpj: "16701716001713",
                companyId: 154,
                shippingSupplierCdlcCode: null,
                shippingSupplierSapCode: 20380
            },
            destinySupplier: {
                label: 1283 + " - " + "FIAT AUTO ARGENTINA S.A                      ", 
                code: 1283,
                name: "FIAT AUTO ARGENTINA S.A                      ",
                cnpj: "00000000001283",
                companyId: 154,
                codstars: "08162"
             },
            vehicleType: { 
                code: "03", 
                label: "03 - TRUCK"  
            },
            vehicleType2: { 
                code: "03", 
                label: "03 - TRUCK"  
            },
            vehicleType3: { 
                code: "03", 
                label: "03 - TRUCK"  
            },
            knowledgeNumber: ""
        }
    });
    
    const Incluir = async () => {
        var formData = getValues();

        var validate = await yupValidationOnSubmit();
        if(!validate) return;

        let asn : ASNPost = {
            Id: 0,
            CompanyId: +user.company.companyID,
            AsnNumber: "",
            OriginSupplierId: formData.originSupplier.code,
            OriginSupplierCorporateName: formData.originSupplier.name,
            OriginSupplierCdlcCode: formData.originSupplier.shippingSupplierCdlcCode,
            OriginSupplierSapCode: formData.originSupplier.shippingSupplierSapCode,
            DestinationSupplierId: formData.destinySupplier.code,
            DestinationSupplierCorporateName: formData.destinySupplier.name,
            DestinationSupplierCodStars: "08162",
            ShippingCompanySupplierId: formData.supplier.code,
            ShippingCompanySupplierCorporateName:  formData.supplier.name,
            ShippingCompanySupplierScacCode: formData.supplier.shippingSupplierCdlcCode,
            ShippingCompanySupplierSapCode:  formData.supplier.shippingSupplierSapCode,
            VehicleType: formData.vehicleType.code,
            VehicleBrandDescription: formData.vehicleBrand,
            VehiclePlateNumber:formData.motorVehiclePlateNumber,
            CartPlateNumber:formData.cartPlateNumber,
            VehicleType2: formData.vehiclePlateNumber2 != null && 
                          formData.vehiclePlateNumber2 != "" ?
                           formData.vehicleType2.code : null,
            VehiclePlateNumber2:formData.vehiclePlateNumber2,
            VehicleType3: formData.vehiclePlateNumber3 != null && 
                          formData.vehiclePlateNumber3 != "" ?
                          formData.vehicleType3.code : null,
            VehiclePlateNumber3:formData.vehiclePlateNumber3,
            CTENumber: 0,
            HarborLetterNumber: formData.harborLetterNumber,
            Invoices: [],
            Remitos:  formData.remitos,
            VehicleDescription: formData.vehicleType.label.substring(5, formData.vehicleType.label.length),
            VehicleDescription2: formData.vehicleType2.label.substring(5, formData.vehicleType2.label.length),
            VehicleDescription3: formData.vehicleType3.label.substring(5, formData.vehicleType3.label.length),
            Discriminator: "AsnArg"
        
        }

        setCircularLoading(true);  
        
        if(params.asnId === null)
        {
            AsnApi.postAsn(asn)
                .then(() => {enqueueSnackbar(t("successAdd"), { variant: 'success' });  setSuccess(true);})
                .finally(() => { setCircularLoading(false); });
        }
        else
        {
            asn.Id = +params.asnId!;
            asn.AsnNumber = asn.AsnNumber??"";

            AsnApi.putAsn(asn)
                .then(() => {enqueueSnackbar(t("successSaved"), { variant: 'success' });  setSuccess(true);})
                .finally(() => { setCircularLoading(false); });
        }
    }

    async function Emitir() {
        var formData = getValues();

        var validate = await yupValidationOnSubmit();
        if(!validate) return;

        let asn : ASNPost = {
            Id: 0,
            CompanyId: +user.company.companyID,
            AsnNumber: "",
            OriginSupplierId: formData.originSupplier.code,
            OriginSupplierCorporateName: formData.originSupplier.name,
            OriginSupplierCdlcCode: formData.originSupplier.shippingSupplierCdlcCode,
            OriginSupplierSapCode: formData.originSupplier.shippingSupplierSapCode,
            DestinationSupplierId: formData.destinySupplier.code,
            DestinationSupplierCorporateName: formData.destinySupplier.name,
            DestinationSupplierCodStars: "08162",
            ShippingCompanySupplierId: formData.supplier.code,
            ShippingCompanySupplierCorporateName:  formData.supplier.name,
            ShippingCompanySupplierScacCode: formData.supplier.shippingSupplierCdlcCode,
            ShippingCompanySupplierSapCode:  formData.supplier.shippingSupplierSapCode,
            VehicleType: formData.vehicleType.code,
            VehicleBrandDescription: formData.vehicleBrand,
            VehiclePlateNumber:formData.motorVehiclePlateNumber,
            CartPlateNumber:formData.cartPlateNumber,
            VehicleType2: formData.vehiclePlateNumber2 != null && 
                          formData.vehiclePlateNumber2 != "" ?
                           formData.vehicleType2.code : null,
            VehiclePlateNumber2:formData.vehiclePlateNumber2 != null && 
            formData.vehiclePlateNumber2 != "" ? formData.vehiclePlateNumber2 : null,
            VehicleType3: formData.vehiclePlateNumber3 != null && 
                          formData.vehiclePlateNumber3 != "" ?
                          formData.vehicleType3.code : null,
            VehiclePlateNumber3: formData.vehiclePlateNumber3 != null && 
            formData.vehiclePlateNumber3 != "" ?formData.vehiclePlateNumber3 : null,
            CTENumber: 0,
            HarborLetterNumber: formData.harborLetterNumber,
            Invoices: [],
            Remitos:  formData.remitos,
            VehicleDescription: formData.vehicleType.label.substring(5, formData.vehicleType.label.length),
            VehicleDescription2: formData.vehicleType2.label.substring(5, formData.vehicleType2.label.length),
            VehicleDescription3: formData.vehicleType3.label.substring(5, formData.vehicleType3.label.length),
            Discriminator: "AsnArg"
        }

        setCircularLoading(true);    
        if(params.asnId == null)
        {
            AsnApi.SubmitAsn(asn)
            .then(() => {enqueueSnackbar(t("successIssued"), { variant: 'success' }); setSuccess(true);})
            .finally(() => { setCircularLoading(false); });
        }
        else
        {
            asn.Id = +params.asnId;
            AsnApi.SubmitAsn(asn)
            .then(() => {enqueueSnackbar(t("successIssued"), { variant: 'success' }); setSuccess(true);})
            .finally(() => { setCircularLoading(false); });
        }       
    }

    function ChangeAsnStatus(status: string) {
        setCircularLoading(true);
        if(status == "REC")
        {
            AsnApi.receiptAsn(asn?.id!)
            .then(() => {enqueueSnackbar(t("successReceived"), { variant: 'success' });setSuccess(true);})
                .finally(() => { setCircularLoading(false);  });
        }
        else if(status = "CAN")
        {
            AsnApi.cancelAsn(asn?.id!)
            .then(() => {enqueueSnackbar(t("successCancel"), { variant: 'success' }); setSuccess(true);})
                .finally(() => { setCircularLoading(false);});
        }
    }

    const yupValidationOnSubmit = async () => {        

        var data = getValues();

        clearErrors(["originSupplier"])
        clearErrors(["destinySupplier"])
        clearErrors(["supplier"])
        clearErrors(["vehicleBrand"])
        clearErrors(["cartPlateNumber"])

        try {
            const schema = Yup.object().shape({
                originSupplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                destinySupplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                supplier: Yup.object().nullable()
                    .required(tval("requiredField")),
                vehicleBrand: Yup.string().nullable()
                    .required(tval("requiredField")),
                cartPlateNumber: Yup.string().nullable()
                    .required(tval("requiredField")),
            })
            await schema.validate(data, {
                abortEarly: false,
            })

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    setError(error.path?.split('.')[0] as "originSupplier" | "destinySupplier" | "supplier" | "vehicleBrand" | "cartPlateNumber", { message: error.message })
                })
            }

            return false
        }

        return true
    }

    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">
            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PageTitle title={t("issueASNARG")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={() => {}}  >                       

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={2} style={{paddingRight:"10px"}}>
                            <Grid item xs={4} >
                                <SelectSupplier
                                    id="originSupplier"
                                    name="originSupplier"
                                    label={t("origin")}
                                    multiple={false}
                                    control={control}
                                    setValue={setValue}
                                    loadUserSupplier={params.asnId === null}
                                    style={{  width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={4} >
                                <SelectSupplier
                                    id="destinySupplier"
                                    name="destinySupplier"
                                    label={t("destiny")}
                                    multiple={false}
                                    control={control}
                                    setValue={setValue}
                                    loadUserSupplier={params.asnId === null}
                                    style={{  width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={4} >
                                <SelectSupplier
                                    id="supplier"
                                    name="supplier"
                                    label={t("ShippingCompany")}
                                    multiple={false}
                                    control={control}
                                    serviceType="T"
                                    style={{  width: '100%' }}
                                />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <SelectVehicleType 
                                    label={t('mainVehicle')} 
                                    name={'vehicleType'}
                                    control={control}/>
                            </Grid>

                            <Grid item xs={2}>
                                <TextField InputLabelProps={{shrink:true}} disable={true} label={t("motorVehiclePlate")} name="motorVehiclePlateNumber" mask="aaa9*99" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("vehicleBrand")} name="vehicleBrand" control={control}  fullWidth InputLabelProps={{shrink:true}} />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("cartPlateNumber")} name="cartPlateNumber" mask="aaa9*99" control={control} InputLabelProps={{shrink:true}} fullWidth />
                            </Grid>
                        </Grid>   

                         <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <SelectVehicleType 
                                    label={t('vehicleType') + " 2:"} 
                                    name={'vehicleType2'}
                                    control={control}/>
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("vehiclePlateNumber")} name="vehiclePlateNumber2" mask="aaa9*99" control={control} InputLabelProps={{shrink:true}} fullWidth />
                            </Grid>
                        </Grid>    

                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <SelectVehicleType 
                                    label={t('vehicleType') + " 3:"} 
                                    name={'vehicleType3'}
                                    control={control}/>
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("vehiclePlateNumber")} name="vehiclePlateNumber3" mask="aaa9*99" control={control} InputLabelProps={{shrink:true}} fullWidth />
                            </Grid>
                        </Grid>    

                        <Grid container spacing={2}>                           
                            <Grid item xs={2}>
                                <TextField label={"Carta de Porto: "} name="harborLetterNumber" control={control} fullWidth />
                            </Grid>
                        </Grid>  

                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <ASNRemitoList
                                    control={control}
                                    title={t("remitos")}
                                    name={"remitos"}
                                    allowAdd={asn === null || asn && asnStatusesToAlter.includes(asn.asnStatus)}
                                    allowDelete={asn === null || asn && asnStatusesToAlter.includes(asn.asnStatus)}
                                    Mvm={null}/>
                            </Grid>
                        </Grid> 


                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={1} style={{height:"30px"}}>
                        </Grid>

                        <Grid container spacing={2}>
                            <ButtonUI onClick={() => {history.replace('/ASN/AsnBra')} } color="secondary">{_t("cancel")}</ButtonUI>

                            {
                                (asn === null || (asn && asnStatusesToAlter.includes(asn.asnStatus))) && 
                                    <ButtonUI onClick={() => {Incluir()} } color="primary">{params.asnId == null? _t("add") : _t("save")}</ButtonUI>
                            }
                            {
                                (asn === null || (asn?.asnStatus === "RAS")) &&
                                    <ButtonUI onClick={() => {Emitir()} } color="primary" >{t("submitAsn")}</ButtonUI>
                            }
                            {
                                asn && asn.asnStatus === "EMT" && 
                                    (
                                        <>
                                            <ButtonUI onClick={() => {ChangeAsnStatus("REC")} } color="primary" >{t("receiveAsn")}</ButtonUI>
                                            <ButtonUI onClick={() => {ChangeAsnStatus("CAN")} } color="primary" >{t("cancelAsn")}</ButtonUI>
                                        </>
                                    )
                            }
                        </Grid>
                    </form>
                </div>
            </div>
        </Container>
    )
}
export default SubmitASN;